(function () {
  const STORAGE_KEY = 'baseprime_quote_items';

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateQuoteCount();

    document.dispatchEvent(
      new CustomEvent('baseprime:quote-updated', {
        detail: { items: items }
      })
    );
  }

  function addItem(product) {
    const items = getItems();

    const existingItem = items.find(
      item =>
        String(item.variantId || item.productId) ===
        String(product.variantId || product.productId)
    );

    if (existingItem) {
      existingItem.quantity += product.quantity || 1;
    } else {
      items.push({
        productId: product.productId || '',
        variantId: product.variantId || '',
        title: product.title || '',
        sku: product.sku || '',
        url: product.url || '',
        image: product.image || '',
        price: product.price || '',
        quantity: product.quantity || 1
      });
    }

    saveItems(items);
  }

  function removeItem(id) {
    const items = getItems().filter(
      item =>
        String(item.variantId || item.productId) !== String(id)
    );

    saveItems(items);
  }

  function updateQuantity(id, quantity) {
    const items = getItems();
    const item = items.find(
      item =>
        String(item.variantId || item.productId) === String(id)
    );

    if (!item) return;

    const newQuantity = parseInt(quantity, 10);

    if (newQuantity <= 0) {
      removeItem(id);
      return;
    }

    item.quantity = newQuantity;
    saveItems(items);
  }

  function clearQuote() {
    saveItems([]);
  }

  function getCount() {
    return getItems().reduce(
      (total, item) => total + Number(item.quantity || 1),
      0
    );
  }

  function updateQuoteCount() {
    const count = getCount();

    document
      .querySelectorAll('[data-bp-quote-count]')
      .forEach(element => {
        element.textContent = count;
      });
  }

  function showAddedState(button) {
    const originalText =
      button.getAttribute('data-original-text') ||
      button.textContent.trim();

    button.setAttribute('data-original-text', originalText);
    button.classList.add('bp-quote-added');

    const textElement = button.querySelector('[data-bp-quote-button-text]');

    if (textElement) {
      textElement.textContent = 'Added to Quote';
    } else {
      button.textContent = 'Added to Quote ✓';
    }

    setTimeout(() => {
      button.classList.remove('bp-quote-added');

      if (textElement) {
        textElement.textContent = originalText;
      } else {
        button.textContent = originalText;
      }
    }, 1600);
  }

document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-bp-add-to-quote]');

  if (!button) return;

  event.preventDefault();

  const productForm = button.closest('form');

  const variantInput = productForm
    ? productForm.querySelector('[name="id"]')
    : null;

  const quantityInput = productForm
    ? productForm.querySelector('[name="quantity"]')
    : null;

  const currentVariantId = variantInput
    ? variantInput.value
    : button.dataset.variantId;

  const variantDataElement = productForm
    ? productForm.querySelector('[data-bp-variant-data]')
    : null;

  let selectedVariant = null;

  if (variantDataElement) {
    try {
      const variants = JSON.parse(variantDataElement.textContent);

      selectedVariant = variants.find(function (variant) {
        return String(variant.id) === String(currentVariantId);
      });
    } catch (error) {
      selectedVariant = null;
    }
  }

  const currentQuantity = quantityInput
    ? parseInt(quantityInput.value || '1', 10)
    : 1;

  addItem({
    productId: button.dataset.productId,
    variantId: currentVariantId,

    title:
      selectedVariant &&
      selectedVariant.title &&
      selectedVariant.title !== 'Default Title'
        ? button.dataset.productTitle + ' — ' + selectedVariant.title
        : button.dataset.productTitle,

    sku: selectedVariant
      ? selectedVariant.sku
      : button.dataset.productSku,

    url: button.dataset.productUrl,
    image: button.dataset.productImage,

    price: selectedVariant
      ? selectedVariant.price
      : button.dataset.productPrice,

    quantity: currentQuantity
  });

  showAddedState(button);
});

  document.addEventListener('DOMContentLoaded', updateQuoteCount);

  window.BasePrimeQuote = {
    getItems,
    addItem,
    removeItem,
    updateQuantity,
    clearQuote,
    getCount,
    updateQuoteCount
  };
})();